<template>
    <div>
        <a id="tabindex-drop-item" tabindex="-1" class="opacity-0 absolute -z-1"></a>
        <a
            href="#main-content"
            class="skip-link fixed top-0 left-1/2 -translate-y-full -translate-x-1/2 focus:translate-y-0"
        >
            {{ $t('a11y.skip_to_main_content') }}
        </a>
    </div>
</template>

<script>
export default {
    name: 'MainSkipToContentLink',
};
</script>

<style scoped></style>
